module.exports = __webpack_public_path__ + "static/media/mananagaram.d3f884bd.png";